import React, { useRef } from 'react';
import { useIsVisible } from 'shared/hooks/visibility';
import { useDebouncedEffect } from 'shared/hooks/debounced-effect';

const DEFAULT_DEBOUNCE_TIMEOUT = 300;

export interface InfiniteScrollTableWrapperProps
  extends React.HTMLAttributes<HTMLTableSectionElement> {
  onReachedEnd: (() => Promise<any>) | null;
  debounceTimeout?: number;
}

export const InfiniteScrollTableWrapper = ({
  children,
  onReachedEnd,
  debounceTimeout,
  ...props
}: InfiniteScrollTableWrapperProps) => {
  const ref = useRef<HTMLTableCellElement>(null);
  const isVisible = useIsVisible(ref);

  // Use debounced effect to prevent rapid invocations
  useDebouncedEffect(
    () => {
      if (onReachedEnd && isVisible) {
        onReachedEnd();
      }
    },
    [isVisible, onReachedEnd],
    debounceTimeout ?? DEFAULT_DEBOUNCE_TIMEOUT,
  );

  return (
    <tbody {...props}>
      {children}
      <tr>
        <td ref={ref}></td>
      </tr>
    </tbody>
  );
};
